<template>
  <w-flex v-if="needAutosave != undefined" id="autosaveinfo" class="autosave-info" :gap="2">
    <span class="color-neutral-600"> Ostatni zapis: </span>

    <w-flex v-if="needAutosave" align="center" class="color-caution-600" :gap="1">
      <w-icon size="sm" icon="warning" />

      Brak
    </w-flex>

    <w-flex v-else align="center" class="color-success-800" :gap="1">
      <w-icon size="sm" icon="check" />

      Aktualny
    </w-flex>
  </w-flex>
</template>

<script setup lang="ts">
defineProps<{
  needAutosave?: boolean;
}>();

defineEmits({
  'prev-clicked': null,
  'next-clicked': null,
  cancel: null,
  save: null,
  'change-tab': null,
});
</script>

<style lang="scss">
.autosave-info {
  font-size: w.font('xsmall');
}
</style>
